import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStatusCountCardSmallStyles = makeStyles<Theme>((theme) => ({
  link: {
    width: '100%'
  },
  card: {
    padding: '16px',
    width: '100%',
    minWidth: '100px',
    height: '150px',
    borderRadius: '10px',
    [theme.breakpoints.down(860)]: {
      height: '135px'
    }
  },
  clickable: {
    cursor: 'pointer',
    transition: 'transform 0.15s ease-in-out',
    [theme.breakpoints.down('sm')]: {
      boxShadow: '0 0 8px 0 rgb(82 63 105 / 15%) !important'
    },
    '&:hover': {
      transform: 'scale3d(1.02, 1.02, 1)',
      boxShadow: '0 0 100px 0 rgb(82 63 105 / 13%) !important',
      [theme.breakpoints.down('sm')]: {
        boxShadow: '0 0 8px 0 rgb(82 63 105 / 11%) !important'
      }
    },
    '&:active': { transform: 'scale3d(1, 1, 1)' }
  },
  rightSide: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  avatar: {
    width: '53px',
    height: '53px',
    marginTop: '-4px',
    marginRight: '-4px',
    [theme.breakpoints.down('sm')]: {
      width: '45px',
      height: '45px'
    }
  },
  icon: {
    width: '36px',
    height: '36px',
    [theme.breakpoints.down('sm')]: {
      width: '30px',
      height: '30px'
    }
  },
  title: {
    fontWeight: 800,
    fontSize: '15px',
    marginTop: '-0.35rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      height: '28px'
    },
    [theme.breakpoints.down(340)]: {
      fontSize: '12px'
    }
  },
  subtitle: {
    color: '#A8A8A8',
    fontSize: '11px',
    [theme.breakpoints.down(860)]: {
      display: 'none'
    }
  },
  count: {
    fontSize: '65px',
    lineHeight: 1,
    marginBottom: '-8px',
    [theme.breakpoints.down(1400)]: {
      fontSize: '60px'
    },
    [theme.breakpoints.down(1300)]: {
      fontSize: '57px'
    },
    [theme.breakpoints.down(1234)]: {
      fontSize: '55px'
    },
    [theme.breakpoints.down(1134)]: {
      fontSize: '50px'
    },
    [theme.breakpoints.down(860)]: {
      fontSize: '45px'
    },
    [theme.breakpoints.down(600)]: {
      fontSize: '40px'
    },
    [theme.breakpoints.down(460)]: {
      fontSize: '37px'
    },
    [theme.breakpoints.down(340)]: {
      fontSize: '35px'
    },
    [theme.breakpoints.down(320)]: {
      fontSize: '25px'
    }
  }
}));
